
$(document).ready(function(){

  // Show dropdown on mouse hover over brand logo
  // Disabled as it poses display issues on smaller screens (that are devices with mouse interface)
  // To enable, simply uncomment the following lines
  /*
  $(".site-header .grid--no-gutters .grid__item.logo-align--left").mouseover(function(){
    $(".desktop-menu").show();
  });
  */
  
  // This is set in the btn-add-to-cart.liquid snippit and
  // is a Boolean, true if Klaviyo Back In Stock button is used.
  var USE_KLAVIYO_BIS = window.__neo_atcActive;
  
  if (navigator.userAgent.indexOf("Firefox") > 0) {
    $('#shopify-section-header').addClass('firefox');
  } else if (isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
    $('body').addClass('safari');
  }

  // Show dropdown on mouse hover over nav bar items
  $("#SiteNav").mouseover(function(){
    $(".desktop-menu").show();
  });

  // Show dropdown on mouse hover over dropdown itself
  $(".desktop-menu").mouseover(function(){
    $(".desktop-menu").show();
  });
  $(".desktop-menu").mouseover(function(){
    $(this).show();
  });

  // For the functions below, hide dropdown only applies when mouse 
  // leaves either the dropdown menu itself, or leaves the respective elements declared below.

  // Hide dropdown if mouse leaves brand logo 
  $(".site-header .grid--no-gutters .grid__item.logo-align--left").mouseleave(function(){
    $(".desktop-menu").hide();
  });

  // Hide dropdown if mouse leaves nav bar items
  $("#SiteNav").mouseleave(function(){
    $(".desktop-menu").hide();
  });

  // Hide dropdown if mouse leaves dropdown itself
  $(".desktop-menu").mouseleave(function(){
    $(".desktop-menu").hide();
  }); 
  $(".desktop-menu").mouseleave(function(){
    $(this).hide();
  });

  // move dynamic menu items into custom menu
  $('#menu-1 ul li').appendTo('.custom-menu .first');
  $('#menu-2 ul li').appendTo('.custom-menu .second');
  $('#menu-3 ul li').appendTo('.custom-menu .third');
  $('#menu-4 ul li').appendTo('.custom-menu .fourth');

  // add sticky header class to style menu when scrolled down
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 300) {
      $('#shopify-section-header').addClass('sticky--header');
    } else {
      $('#shopify-section-header').removeClass('sticky--header');
    }
  });

  // Show Can We Help side banner popup on click
  /* Feature on HOLD
  var windowWidth = jQuery(window).width();
  $(".help-side-popup, .help-side-popup-close").click(function(){
    if($(".help-side-popup").attr("trigger")==="0" && $(".help-side-popup-close").attr("trigger")==="0"){
      if ($(".help-side-popup").parents(".template-index").length <= 0) {

        $(".help-side-popup").css(
          {
            "opacity": "0",
            "display": "flex",
            "flex-direction": "column",
            "align-items": "center"
          });
      }
      $(".help-side-popup-outer").css({"display": "block"});
      if (windowWidth < 768) {
        $(".help-side-popup-outer").animate({"width": "284px", opacity: 0.15}, 700);
        $(".help-side-popup").animate({"right": "216px", opacity: 0.95}, 700);
      } else {
        $(".help-side-popup-outer").animate({"width": "372px", opacity: 0.15}, 700);
        $(".help-side-popup").animate({"right": "300px", opacity: 0.95}, 700);
      }
      $(".help-side-popup-box").animate({"right": "-1px"}, 700);
      $(".help-side-popup, .help-side-popup-close").attr("trigger","1");
    }
    else{
      if ($(".help-side-popup").parents(".template-index").length > 0) {
        $(".help-side-popup").animate({"right": "0px", opacity: 0.6}, 700);
        $(".help-side-popup-outer").animate({"width": "70px"}, 700);
      } else {
        $(".help-side-popup").animate({"right": "0px", opacity: 0}, 700);
        $(".help-side-popup-outer").animate({"width": "70px", opacity: 0}, 700).css({"display": "none"});
      }
      $(".help-side-popup-box").animate({scrollTop: 0}, 100);
      $(".help-side-popup-box").animate({"right": "-100vw"}, 700);
      $(".help-side-popup, .help-side-popup-close").attr("trigger","0");
    }
  });

  
  // footer 'can we help' trigger click
  $('.can-help a').on('click', function(){
    $('.help-side-popup').trigger('click');
  });
  */

  // Scroll animation for arrow down
  if (jQuery(window).width() < 992) {
    $(".category-down").click(function() {
      $('html, body').animate({
          scrollTop: ($("#our-technology, #our-technology-tab").offset().top - 40) * getZoomPercentage()
      }, 1000);
    });
    $(".mh-down").click(function() {
      $('html, body').animate({
          scrollTop: ($("#highlights").offset().top - 40) * getZoomPercentage()
      }, 1000);
    });
    $(".template-blog .blogs-down").click(function() {
      $('html, body').animate({
          scrollTop: ($("#highlights").offset().top - 40) * getZoomPercentage()
      }, 1000);
    });
  
  } else {
    $(".category-down").click(function() {
      $('html, body').animate({
          scrollTop: ($("#our-technology, #our-technology-tab").get(0).offsetTop) * getZoomPercentage()
      }, 1000);
    });
    $(".mh-down").click(function() {
      $('html, body').animate({
          scrollTop: ($("#highlights").offset().top) * getZoomPercentage()
      }, 1000);
    });
    $(".template-blog .blogs-down").click(function() {
      $('html, body').animate({
          scrollTop: ($("#highlights").offset().top) * getZoomPercentage()
      }, 1000);
    });
  }

  function getZoomPercentage() {
    let zoom = 1;
    if ($(window).width() >= 831 && $(window).width() <= 970) {
      zoom = 0.9;
    } else if ($(window).width() > 970){
      zoom = 0.7;
    }
    return zoom;
  }
  if ($("body").hasClass("challenge")) {
    $('html, body').animate({
      scrollTop: $('body.challenge').offset().top
    }, 'slow');
  }
  $(".fsdr-title h2, .ssdr-title h2, .mh-tested-sec h3").click(function() {
    window.location.href = "/pages/why-us?#ul-verification";
  });
  if (jQuery(window).width() >= 768){
    $(".custom-latest-blog .latest-blog-posts-list li:first-child .article__grid-image-wrapper").insertBefore(".custom-latest-blog .latest-blog-posts-list li:last-child .blog-title");
    $(".custom-latest-blog .latest-blog-posts-list li:last-child .article__grid-image-wrapper:first").insertAfter(".custom-latest-blog .latest-blog-posts-list li:first-child .read-more-btn");
    
    $(".mobile-only-break").css({"display": "none"});
    $(".women-blog-mobile, .men-blog-mobile").css({"display": "none"});
    $(".women-blog-non-mobile, .men-blog-non-mobile").css({"display": "inline"});
    $(".template-blog").addClass('large-resize');
  }
  else{
    $(".mobile-only-break").css({"display": "inline"});
    $(".women-blog-mobile, .men-blog-mobile").css({"display": "inline"});
    $(".women-blog-non-mobile, .men-blog-non-mobile").css({"display": "none"});
    $(".template-blog").addClass('small-resize');
  }
  $(window).on('resize', function() {
    if (jQuery(window).width() >= 768){
      $(".women-blog-mobile, .men-blog-mobile").css({"display": "none"});
      $(".women-blog-non-mobile, .men-blog-non-mobile").css({"display": "inline"});
      if(!$(".template-blog").hasClass("large-resize")){
        $(".mens-mens-health .shg-c-lg-6:first-child .shogun-image-container").insertAfter(".mens-mens-health .shg-c-lg-6:first-child .mh-sec-desc");
        $(".custom-latest-blog .latest-blog-posts-list li:first-child .article__grid-image-wrapper").insertBefore(".custom-latest-blog .latest-blog-posts-list li:last-child .blog-title");
        $(".custom-latest-blog .latest-blog-posts-list li:last-child .article__grid-image-wrapper:first").insertAfter(".custom-latest-blog .latest-blog-posts-list li:first-child .read-more-btn");
      }
      $(".template-blog").addClass('large-resize').removeClass('small-resize');
    }
    else{
      $(".mobile-only-break").css({"display": "inline"});
      $(".women-blog-mobile, .men-blog-mobile").css({"display": "inline"});
      $(".women-blog-non-mobile, .men-blog-non-mobile").css({"display": "none"});      
      if(!$(".template-blog").hasClass("small-resize")){
        $(".custom-latest-blog .latest-blog-posts-list li:first-child .article__grid-image-wrapper").insertBefore(".custom-latest-blog .latest-blog-posts-list li:last-child .blog-title");
        $(".custom-latest-blog .latest-blog-posts-list li:last-child .article__grid-image-wrapper:first").insertBefore(".custom-latest-blog .latest-blog-posts-list li:first-child .blog-title");
        $(".mens-mens-health .shg-c-lg-6:first-child .shogun-image-container").insertBefore(".mens-mens-health .shg-c-lg-6:first-child .mh-sec-title");
        $(".mens-mens-health .shg-c-lg-6:last-child .shogun-image-container").insertBefore(".mens-mens-health .shg-c-lg-6:last-child .mh-sec-title");
      }
      $(".template-blog").addClass('small-resize').removeClass('large-resize');
    }
  });
  $(".mobile-nav__item").click(function(){
    $(this).children(".mobile-nav__dropdown").slideToggle();
    $(this).children().toggleClass("active");
  });
  $(".site-header__menu").click(function(){
    $("#shopify-section-header").toggleClass("active");
  });

  // Fix the html structure of the product description tabs on mobile and desktop.
  initProdTabContent();
  $(window).resize(
    $.debounce(100, function() {
      initProdTabContent();
      moveGenderSelector();
    })
  );
  
  function initProdTabContent() {
    if (jQuery(window).width() <= 991 && $(".prod_tab_content .shogun-tabs.shogun-rounded > li.cust-tab-1").length == 0){
      var divs = document.querySelectorAll(".template-product .shogun-tabs-body.shogun-rounded > div.shogun-tab-content");

      // loop over them
      for (var i = 0; i < divs.length; i++) {
        // add the unique class using whatever class-naming system you prefer
        divs[i].classList.add("cust-tab-cont" + (i+1));
      }

      var divs = document.querySelectorAll(".template-product .prod_tab_content .shogun-tabs.shogun-rounded > li");

      // loop over them
      for (var i = 0; i < divs.length; i++) {
        // add the unique class using whatever class-naming system you prefer
        divs[i].classList.add("cust-tab-" + (i+1));
        $(".template-product .cust-tab-cont" + (i + 1)).insertAfter(divs[i]);
      }
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont1").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-1");
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont2").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-2");
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont3").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-3");
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont4").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-4");
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont5").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-5");
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont6").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-6");
      // $(".template-product .shogun-tabs-body.shogun-rounded .shogun-tab-content.cust-tab-cont7").insertAfter(".template-product .prod_tab_content .shogun-tabs.shogun-rounded li.cust-tab-7");
    } else if ($(window).width() > 991 && $(".prod_tab_content .shogun-tabs.shogun-rounded > li.cust-tab-1").length) {
      $('div[class*="cust-tab-cont"]').each(function() {
        $(this).appendTo(".template-product .shogun-tabs-body.shogun-rounded");
      });
      $(".template-product .shogun-tabs-body.shogun-rounded > div.shogun-tab-content").attr('class', (i, c) => {
        return c.replace(/(^|\s)cust-tab-cont\S+/g, '');
      });
      $(".template-product .prod_tab_content .shogun-tabs.shogun-rounded > li").attr('class', (i, c) => {
        return c.replace(/(^|\s)cust-tab-\S+/g, '');
      });
      $('.shogun-tab-active').removeClass('shogun-tab-active');
      $('.shogun-tab:first, .shogun-tab-content:first').addClass('shogun-tab-active');
    }

    if (jQuery(window).width() <= 767 && $('.product-form__item--quantity + .bundle-ofr').length == 0){
      $(".mens-mens-health .shg-c-lg-6:first-child .shogun-image-container").insertBefore(".mens-mens-health .shg-c-lg-6:first-child .mh-sec-title");
      $(".mens-mens-health .shg-c-lg-6:last-child .shogun-image-container").insertBefore(".mens-mens-health .shg-c-lg-6:last-child .mh-sec-title");
      // $(".template-product .pro-size-help").insertAfter(".template-product .product-form__item.product-form__item--quantity");
      $(".template-product .bundle-ofr").insertAfter(".template-product .product-form-product-template .pro-size-help");
      $(".template-article .return-link-wrapper").insertAfter(".template-article .artical-main-content .rte.blog-desc-main");
    }

    if (jQuery(window).width() <= 1024){
      /*$(".acc-delv-add .acc-edit-btn").insertAfter(".cos-acc-details");*/
      $(".wu-show-txt a").click(function() {
        $(this).parent().siblings().toggleClass('read-more');
        if($(this).parent().siblings().hasClass('read-more')){
          $(this).text("See Less");
        }
        else{
          $(this).text("See More");
        }
      });
    }
  }

  $(".site-footer .site-footer__item-inner--link_list .h4").click(function(){
    $(this).siblings(".site-footer__linklist").slideToggle();
  });
  $(".template-product .prod_tab_content .shogun-tabs.shogun-rounded > li").click(function(){
    $(this).next().toggleClass('shogun-tab-active');
  });

  if ($(window).width() >= 768 && $(window).width() <= 991){
    $(".acc-delv-add .acc-edit-btn").insertAfter(".cos-acc-details");
  }
  if ($(window).width() <= 767){
    $(".myaccount .acc-edit-btn").insertAfter(".acc-interest");
  }

  /* select ul li */
  $(".custom-blog-link").on("click", ".init", function() {
    $(this).closest(".custom-blog-link").children('li:not(.init)').toggle();
    $(".custom-blog-link").toggleClass('active');
  });

  var allOptions = $("ul").children('li:not(.init)');
  $(".custom-blog-link").on("click", "li:not(.init)", function() {
      allOptions.removeClass('selected');
      $(this).addClass('selected');
      $(".custom-blog-link").children('.init').html($(this).html());
      allOptions.toggle();
  });

  if($('body').hasClass('template-blog')){

    //Move tags from bottom of blog page to the dropdown section
    var $tags = $('.blog-tags-container').html();
    $('.template-blog .custom-blog-link').append($tags);

    var liText = '', 
        $liList = $('.template-blog .custom-blog-link li:not(.init)'), 
        listForRemove = [];

    //Sort list alphabetically
    $liList.sort(function(a, b) {
      var aText = $(a).text().trim(), bText = $(b).text().trim();
      return aText < bText ? -1 : aText > bText ? 1 : 0;
    }).appendTo('.template-blog .custom-blog-link');

    var path = window.location.pathname;

    //Remove unwanted tags
    if($('body').hasClass('women') || path.indexOf('women') >= 0 || path.indexOf('female') >= 0){
      var unwantedTags = ["prostate"];
    } else {
      var unwantedTags = ["breastfeeding", "new moms", "periods"];
    }

    // Remove duplicate filter on blog pages
    $liList.each(function() {
      var text = $(this).text().trim();
      if (liText.indexOf('|'+ text + '|') == -1) {
        liText += '|'+ text + '|';
      } else {
        listForRemove.push($(this));
      }
      if(unwantedTags.indexOf(text.toLowerCase()) >= 0) {
        listForRemove.push($(this));
      }
    });
    $(listForRemove).each(function () { $(this).remove(); });
  }

  //Fit in SEO headings among group of p tags
  var $seoTags = $('h1.seo-cmspage, h1.seo-productpage, h1.seo-blogpage, h2.seo-cmspage, h2.seo-productpage, h2.seo-blogpage, h3.seo-cmspage, h3.seo-productpage, h3.seo-blogpage');
  $seoTags.each(function() {
    var $prevSibling = $(this).prev(),
        $nextSibling = $(this).next(),
        $nextnextSibling = $nextSibling.next(),
        marginToAdd ='0px',
        lineHeight = '0px';

    //check if close siblings are p
    if($prevSibling.is('p')) {
      $prevSibling.css('display','inline');
      lineHeight = $prevSibling.css('line-height');
    }
    if($nextSibling.is('p') && 
       $nextSibling.css('paddingLeft') == '0px') {
      $nextSibling.css({'display':'inline'});

      //Display inline ignores margins top and bottom
      //So we move margin to the next next sibling to retain spacing between p tags
      marginToAdd = $nextSibling.css('marginBottom');
      $nextnextSibling.css('margin-top',marginToAdd);
      lineHeight = $nextSibling.css('line-height');
    }
    if($prevSibling.is('p') || $nextSibling.is('p')) {
      $(this).css('display','inline');
      //Adjust parent's line height for inline child element inherits it
      $(this).parent().css('line-height',lineHeight);
    }

    //If seo heading is placed on end of paragraph, add bottom spacing to the direct parent
    if($prevSibling.is('p') &&
      (!$nextSibling.text() || !$nextnextSibling.text())) {

        marginToAdd = $prevSibling.css('marginBottom');
        $(this).parent().css('padding-bottom',marginToAdd);
    }
  });

  setTimeout( function(){
    divideModalIntoColumns();
    checkKlaviyoMembership();
  }, 3000);

  setTimeout( function(){
    checkIfFirstVisit();
  }, 60000); //show popup after a minute

  function checkKlaviyoMembership() {
    const newsletterSubscribed = window.sessionStorage.getItem('newsletter-subscribed');
    if (newsletterSubscribed === null && $('#second-signup-modal .modal-inner > div').hasClass('klaviyo-form')) {

    } else {
      $('.already-subscribed').show();
    }
  }

  function checkIfFirstVisit() {
    const newsletterSubscribed = window.sessionStorage.getItem('newsletter-subscribed');
    if (newsletterSubscribed === null && $('#second-signup-modal .modal-inner > div').hasClass('klaviyo-form') && $('.already-subscribed').is(':hidden')) {
      $('#second-signup-modal').show();
      $('body').addClass('unscrollable');
    } else {
      $('.already-subscribed').show();
    }
  }

  $('body').on('click','#first-signup-modal .close',function(e){
    closeSignUpModal($('#first-signup-modal'));
  });

  $('body').on('click','#second-signup-modal .close',function(e){
    closeSignUpModal($('#second-signup-modal'));
  });

  $('body').on('click','#first-signup-modal .sign-up',function(e){
    closeSignUpModal($('#first-signup-modal'));
    setTimeout( function(){
      triggerSecondSignUpModal($('.sign-up-modal-email').val());
    },1000);
    $("html, body").animate({ scrollTop: $(document).height()+1000 }, 1000);
  });
  
  // Close modal when ESCAPE ibutton is pressed or a click to 
  // outside of the modal body is registered.
  document.addEventListener('click', function(e) {
    var rxModalID = /(second|first)-signup-modal/gi;
    if (!e.path || !e.path[0].id.match(rxModalID)) return;

    closeSignUpModal($('#second-signup-modal'));
    closeSignUpModal($('#first-signup-modal'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSignUpModal($('#second-signup-modal'));
    closeSignUpModal($('#first-signup-modal'));
  });  

  $('body').on('click','.newsletter__submit',function(e){
    $('.already-subscribed').hide();
    var footerEmail = $('#ContactFooter-email').val();
    var emailsUsed = sessionStorage.getItem('newsletter-emails');
    var emails = JSON.parse(emailsUsed) || ['content'];
    emails.push('content');
    
    if($('#second-signup-modal .modal-inner > div').hasClass('klaviyo-form') && (emails.indexOf(footerEmail) < 0 || footerEmail == "")) {
      triggerSecondSignUpModal($('#ContactFooter-email').val());
      $('.klaviyo-form [type="email"]')
        .focus()
        .val(footerEmail);

      setTimeout( function(){
        $('.klaviyo-form [type="email"]')
          .focus()
          .val(footerEmail);
      },500);
      $('.already-subscribed').hide();
    } else {
      $('.already-subscribed').show();
    }
  });

  var emailSignUp = '';
  var firstEmailClick = 0;

  function triggerSecondSignUpModal(email) {
    emailSignUp = email;
    firstEmailClick = 0;
    $('body').addClass('unscrollable');
    $('#second-signup-modal').show();
    if(email != '') {
      $('.klaviyo-form [type="email"]')
        .focus()
        .val(email);
    }
  }

  function closeSignUpModal($modal) {
    $modal.hide();
    $('body').removeClass('unscrollable');
  }

  function divideModalIntoColumns() {
    $('#second-signup-modal')
      .find('.klaviyo-form form > div > div rect')
      .attr('rx','10');
    $('#second-signup-modal .modal-content').show();
  }

  function moveGenderSelector() {
  }

  $('body').on('click','.select-items div',function(e){
    if (USE_KLAVIYO_BIS) return; 
    checkProductOptions();
  });

  if($('body').hasClass('template-product')) {
    if (USE_KLAVIYO_BIS) return; 
    checkProductOptions();
  }

  //Do not show Add to Cart btn unless all product options are selected
  function checkProductOptions() {
    var notSelectedCtr = 0;
    var blankOption = '';
    var btnTxt = '';
    var $submitBtn = $('.product-form__cart-submit');
    var $checkerBtn = $('.product-form__cart-checker');
    $submitBtn.show();
    $checkerBtn.hide();

    $('.select-items').each(function() {
      if(!$(this).find('.same-as-selected').length && $(this).find('div').length > 1) {
        notSelectedCtr++;
        blankOption = $(this).closest('.custom_dropdown_selector').attr('data-option');
      }
    });
    
    if(notSelectedCtr == 1) {
      btnTxt = 'SELECT A ' + blankOption;
      $checkerBtn.text(btnTxt);
      $checkerBtn.show();
      $submitBtn.hide();
    }
  }

  //open modal on enter key press
  $('#first-signup-modal .sign-up-modal-email, #ContactFooter-email').on('keypress', function (e) {
    if(e.which === 13){
      $('.already-subscribed').hide();
      var footerEmail = $('#ContactFooter-email').val();
      var emailsUsed = sessionStorage.getItem('newsletter-emails');
      var emails = JSON.parse(emailsUsed) || ['content'];
      
      if($('#second-signup-modal .modal-inner > div').hasClass('klaviyo-form') && (emails.indexOf(footerEmail) < 0 || footerEmail == "")) {
        triggerSecondSignUpModal($('#ContactFooter-email').val());
        $('.klaviyo-form [type="email"]')
          .focus()
          .val(footerEmail);
  
        setTimeout( function(){
          $('.klaviyo-form [type="email"]')
            .focus()
            .val(footerEmail);
        },500);
        $('.already-subscribed').hide();
      } else {
        $('.already-subscribed').show();
      }
    }
  });

  var emailPublic = '';

  $('body').on('keyup','.klaviyo-form [type="email"]',function(e){
    emailPublic = $(this).val();
  });
  $('body').on('change','.klaviyo-form [type="email"]',function(e){
    emailPublic = $(this).val();
  });
  $('body').on('blur','.klaviyo-form [type="email"]',function(e){
    emailPublic = $(this).val();
  });


  $('body').on('click','#second-signup-modal button',function(e){
    waitForFormSuccess('#second-signup-modal button', function() {
      window.sessionStorage.setItem('newsletter-subscribed', true);
      var emailsUsed = JSON.parse(sessionStorage.getItem('newsletter-emails')) || ['content'];
      var email = $('.klaviyo-form [type="email"]').val() || emailPublic;
      emailsUsed.push(email);

      sessionStorage.setItem('newsletter-emails', JSON.stringify(emailsUsed))
      // closeSignUpModal($('#second-signup-modal'));
      $('#second-signup-modal .klaviyo-form form > div > div').addClass('success-message');
      $('#second-signup-modal').addClass('success-container');
      $('.already-subscribed').show();
    });
  });

  const maxTime = 30;
  let count = 0;
  function waitForFormSuccess(selector, callback) {
      if(!$(selector).is(':visible')){
          callback();
      } else {
          if(count <= maxTime){
              setTimeout( function() {
                waitForFormSuccess(selector, callback);
              }, 100);
              count++;
          }
      }
  }
});


